import EmployeeEvaluation from "features/evoluate";

const EmployeeEvaluationPage = () => {
  return <EmployeeEvaluation />;
};

export default EmployeeEvaluationPage;
